import React from 'react';
import Hero from '../components/Hero';
import { motion } from 'framer-motion';
import Banner from '../components/Banner';
import SEO from '../components/SEO';
import '../styles/pages/Home.css';

const Home = () => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            <SEO 
                title="Fortune Cloud Solutions | IT Staffing, Training & Career Development Services" 
                description="Fortune Cloud Solutions offers expert IT staffing, industry-focused training, and career development services to help businesses and professionals succeed in the evolving IT landscape." 
                keywords="IT staffing services, IT training programs, career development IT, cloud solutions company, IT consulting services, IT recruitment agency USA, software training institute, job placement IT services, corporate IT staffing solutions, tech career guidance"
                canonical="https://fcsglobal.us/"
            />
            {/* <Banner title="Welcome to Fortune Cloud" image="/images/home_background.jpg" /> */}
            <Hero />
        </motion.div>
    );
};

export default Home;
